module.exports = "<svg viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 14H14v10c0 .552-.448 1-1 1s-1-.448-1-1V14H2c-.552 0-1-.448-1-1s.448-1 1-1h10V2c0-.552.448-1 1-1s1 .448 1 1v10h10c.552 0 1 .448 1 1s-.448 1-1 1z\" stroke=\"#9A9A9A\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/plus-icon.svg
// module id = T5NG
// module chunks = 89